import React, { ReactElement } from "react";
import { Style } from "App/Routes/GoodsDetail/Style";
import { Time } from "lib/time";
import { ProductDetailStore } from "App/Routes/ProductDetail/Store";
import { ProductDetailActions } from "App/Routes/ProductDetail/Store/ProductDetail";
type Props = {
  readonly createdAt: string;
};

export const ProductDate = ({ createdAt }: Props): ReactElement => (
  <Style.Row>
    <Style.Caption>발매 일자</Style.Caption>
    <Style.InputDate
      type="date"
      defaultValue={Time(createdAt).format("YYYY-MM-DD")}
      required
      min="1900-01-01"
      max="2099-12-31"
      onBlurCapture={event => ProductDetailStore.dispatch(ProductDetailActions.setCreatedAt(event.target.value))}
    />
    <Style.AlertCaption>날짜를 선택해주세요.</Style.AlertCaption>
  </Style.Row>
);
